import { useMutation } from '@apollo/client';
import { useContext } from 'react';
import MainAppContext from '../../../AppContext';
import { NotificationType } from '../../../components/Notification/NotificationComponent';
import { READ_SUB_THEME_TEMPLATE_CHECKLIST_BY_THEME_ID } from '../SubThemeReadService';
import { DELETE_SUB_THEME_TEMPLATE_CHECKLIST } from './SubThemeDeleteMutation';

export interface SubThemeDeleteServiceProps {
  themeId: number;
}

export const useSubThemeDeleteService = ({
  themeId,
}: SubThemeDeleteServiceProps) => {
  const { setNotification } = useContext(MainAppContext);

  const [deleteSubTheme] = useMutation(DELETE_SUB_THEME_TEMPLATE_CHECKLIST, {
    refetchQueries: [
      {
        query: READ_SUB_THEME_TEMPLATE_CHECKLIST_BY_THEME_ID,
        variables: { themeId },
      },
    ],
    awaitRefetchQueries: true,
    onCompleted() {
      setNotification({
        key: 'common:savedSuccess',
        type: NotificationType.SUCCESS,
      });
    },
    onError(error) {
      setNotification({
        key: 'common:generalError',
        type: NotificationType.ERROR,
      });
    },
  });

  const onDelete = async (id: number) => {
    return deleteSubTheme({
      variables: { id: id, deletedDate: new Date() },
    });
  };

  return { onDelete };
};
